import React, { createContext, useState } from 'react';

interface ICommonContext {
  showLoadingOverlay: boolean;
  setShowLoadingOverlay: (value: boolean) => void;
}

interface ICommonProvider {
  children: JSX.Element;
}

export const CommonContext = createContext<ICommonContext>({
  showLoadingOverlay: false,
  setShowLoadingOverlay: () => null,
});

export const CommonProvider = ({ children }: ICommonProvider) => {
  const [showLoadingOverlay, setShowLoadingOverlay] = useState<boolean>(false);

  return (
    <CommonContext.Provider
      value={{
        showLoadingOverlay,
        setShowLoadingOverlay,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};

export default CommonProvider;
